import { jsx } from "react/jsx-runtime";
import BuildCircleOutlinedIcon from "@mui/icons-material/BuildCircleOutlined";
import { validateTidalLicense } from "../../base/index.js";
function BuildCircleOutlined(props) {
  return /* @__PURE__ */ jsx(
    BuildCircleOutlinedIcon,
    {
      "data-testid": "BuildCircleOutlined",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "BuildCircleOutlined",
      "data-tidal-icon-meta": "miscellaneous"
    }
  );
}
BuildCircleOutlined.tidalIconMeta = {
  categories: "miscellaneous",
  name: "BuildCircleOutlined"
};
validateTidalLicense();
export {
  BuildCircleOutlined
};
//# sourceMappingURL=BuildCircleOutlined.js.map
